import { useState } from "react";
import { Edit } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import type { Department } from "@/types/department";
import { DepartmentForm } from "./DepartmentForm";

interface EditDepartmentDialogProps {
  department: Department;
}

export function EditDepartmentDialog({ department }: EditDepartmentDialogProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center justify-center text-muted-foreground hover:text-primary transition-colors"
          aria-label="تعديل الدائرة"
        >
          <Edit className={cn("w-4", "h-4")} />
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader className="text-right">
          <DialogTitle>تعديل الدائرة</DialogTitle>
          <DialogDescription className="sr-only">
            تعديل بيانات الدائرة
          </DialogDescription>
        </DialogHeader>
        <DepartmentForm department={department} setOpen={setOpen} />
      </DialogContent>
    </Dialog>
  );
}
